import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Badge,
} from "reactstrap";

const ChannelHealth = ({
  channels = [],
}) => {

  return (
    <Col xl={4}>
      <Card
        style={{
          height: "100%",
        }}
      >
        <CardHeader>
          <h4 className="card-title mb-0">
            Channel Health
          </h4>
        </CardHeader>

        <CardBody>

          {channels.length === 0 && (
            <div className="text-center text-muted">
              No Channels Connected
            </div>
          )}

          {channels.map(
            (channel) => {

              const healthy =
                channel.enabled &&
                channel.syncInventory &&
                channel.syncRates &&
                channel.syncBookings;

              return (
                <div
                  key={
                    channel._id
                  }
                  className="border rounded p-3 mb-3"
                >

                  <div className="d-flex justify-content-between align-items-center mb-2">

                    <div>
                      <h6 className="mb-0">
                        {channel.channel}
                      </h6>

                      <small className="text-muted">
                        Hotel ID :
                        {" "}
                        {
                          channel.hotelId
                        }
                      </small>
                    </div>

                    <Badge
                      color={
                        healthy
                          ? "success"
                          : channel.enabled
                          ? "warning"
                          : "danger"
                      }
                    >
                      {healthy
                        ? "Healthy"
                        : channel.enabled
                        ? "Partial"
                        : "Disabled"}
                    </Badge>

                  </div>

                  <div className="d-flex flex-wrap gap-2 mb-2">

                    <Badge
                      color={
                        channel.syncInventory
                          ? "success"
                          : "danger"
                      }
                    >
                      Inventory
                    </Badge>

                    <Badge
                      color={
                        channel.syncRates
                          ? "success"
                          : "danger"
                      }
                    >
                      Rates
                    </Badge>

                    <Badge
                      color={
                        channel.syncBookings
                          ? "success"
                          : "danger"
                      }
                    >
                      Bookings
                    </Badge>

                  </div>

                  <small className="text-muted">
                    Updated :
                    {" "}
                    {channel.updatedAt
                      ? new Date(
                          channel.updatedAt
                        ).toLocaleString()
                      : "-"}
                  </small>

                </div>
              );
            }
          )}

        </CardBody>
      </Card>
    </Col>
  );
};

export default ChannelHealth;